export default "__VITE_ASSET__BtYM2EbG__"